/* PrimeMind layers: one rAF loop that turns scroll position into CSS variables.
   [data-pm-stage]   pinned stage, sets --p (0..1 through the stage) and --sw/--sh (pin size)
   [data-pm-circle]  circle reveal, sets --r (0..1 as the element rises into view)
   [data-pm-depth]   parallax, translates by distance from viewport centre * depth
   [data-pm-chapters] + [data-pm-chapter] + [data-pm-pill]  sticky chapter pill
   Reduced motion: stages jump to their end state, nothing moves. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var AUTO_DEPTH = '.product-card__image img, .comparison__image img, .product-tabs__image img';
  var stages = [], circles = [], depths = [], chapterSets = [], ticking = false;

  function all(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

  function collect() {
    stages = all('[data-pm-stage]');
    circles = all('[data-pm-circle]');
    depths = reduce ? [] : all('[data-pm-depth], ' + AUTO_DEPTH);
    chapterSets = all('[data-pm-chapters]').map(function (wrap) {
      var root = wrap.closest('[data-pm-root]') || document;
      return { wrap: wrap, items: Array.prototype.slice.call(wrap.querySelectorAll('[data-pm-chapter]')), pill: root.querySelector('[data-pm-pill]') };
    });
    if (reduce) {
      stages.forEach(function (el) { el.style.setProperty('--p', '1'); });
      circles.forEach(function (el) { el.style.setProperty('--r', '1'); });
    }
    frame();
  }

  function frame() {
    ticking = false;
    var vh = window.innerHeight;

    if (!reduce) {
      stages.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var run = r.height - vh;
        el.style.setProperty('--p', (run > 0 ? clamp(-r.top / run) : 0).toFixed(4));
        el.style.setProperty('--sw', el.clientWidth + 'px');
        el.style.setProperty('--sh', vh + 'px');
      });

      circles.forEach(function (el) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--r', clamp((vh - r.top) / (vh * 0.8)).toFixed(4));
      });

      depths.forEach(function (el) {
        var box = (el.parentElement || el).getBoundingClientRect();
        if (box.bottom < -300 || box.top > vh + 300) return;
        var d = parseFloat(el.getAttribute('data-pm-depth'));
        if (isNaN(d)) d = 0.07;
        var s = parseFloat(el.getAttribute('data-pm-scale'));
        if (isNaN(s)) s = 1.12;
        var off = (box.top + box.height / 2) - vh / 2;
        el.style.transform = 'translate3d(0,' + (-off * d).toFixed(1) + 'px,0) scale(' + s + ')';
      });
    }

    chapterSets.forEach(function (set) {
      if (!set.pill) return;
      var r = set.wrap.getBoundingClientRect();
      var on = r.top < vh * 0.55 && r.bottom > vh * 0.75;
      var label = '';
      set.items.forEach(function (it) {
        if (it.getBoundingClientRect().top < vh * 0.55) label = it.getAttribute('data-pm-chapter');
      });
      if (!label && set.items[0]) label = set.items[0].getAttribute('data-pm-chapter');
      if (set.pill.textContent !== '( ' + label + ' )') set.pill.textContent = '( ' + label + ' )';
      set.pill.classList.toggle('is-on', on);
    });
  }

  function request() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(frame); }
  }

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
  document.addEventListener('shopify:section:load', collect);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collect);
  else collect();
})();
